import { render } from "./KnowhowTip3.vue?vue&type=template&id=5b6f5d4e"
import script from "./KnowhowTip3.vue?vue&type=script&lang=js"
export * from "./KnowhowTip3.vue?vue&type=script&lang=js"

import "./KnowhowTip3.vue?vue&type=style&index=0&id=5b6f5d4e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__